//
//
//
//
//
//
//
//
//

export default {
  name: "TransitionFade",
  methods: {
    beforeLeave(element) {
      element.style.left = `${element.offsetLeft}px`;
      element.style.width = `${element.offsetWidth}px`;
      element.style.height = `${element.offsetHeight}px`;
    },
    afterLeave(element) {
      element.style.left = ``;
      element.style.width = ``;
      element.style.height = ``;
    },
  }
};
